export function takePhoto() {
    // 调用Android拍照并返回Promise
    return new Promise((resolve, reject) => {
        if (!script || typeof script.getGoodsImage !== 'function') {
            return reject('Android接口不可用');
        }

        // 设置回调函数
        window.photoData = "";
        window.onPhotoChunk = (chunk) => {
            window.photoData += chunk;
        };

        window.onPhotoComplete = () => {
            const imgData = "data:image/jpeg;base64," + window.photoData;
            resolve(imgData);
            window.photoData = "";
        };

        window.onPhotoError = (error) => {
            reject(error);
            window.photoData = "";
        };

        // 调用Android接口
        script.getGoodsImage();
    });
}